import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../app/axiosBaseQuery';

export const paymentsApi = createApi({
  reducerPath: 'paymentsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['MyPayments', 'AdminPayments'],
  endpoints: (builder) => ({
    // Investor pays a pending investment via the (simulated) Paystack gateway.
    fundInvestmentPaystack: builder.mutation({
      query: (investmentId) => ({ url: `/investments/${investmentId}/fund/paystack`, method: 'POST' }),
      invalidatesTags: ['MyPayments'],
    }),
    // Admin confirms a bank-transfer payment against a pending investment.
    recordManualPayment: builder.mutation({
      query: ({ investmentId, ...body }) => ({ url: `/admin/investments/${investmentId}/payments`, method: 'POST', data: body }),
      invalidatesTags: ['AdminPayments'],
    }),
    myPayments: builder.query({
      query: () => ({ url: '/me/payments', method: 'GET' }),
      providesTags: ['MyPayments'],
    }),
    adminListPayments: builder.query({
      query: (params) => ({ url: '/admin/payments', method: 'GET', params }),
      providesTags: ['AdminPayments'],
    }),
  }),
});

export const {
  useFundInvestmentPaystackMutation,
  useRecordManualPaymentMutation,
  useMyPaymentsQuery,
  useAdminListPaymentsQuery,
} = paymentsApi;
